module.exports = __webpack_public_path__ + "static/media/importicon.04e99b0e.svg";